/**
 * External dependencies
 */
import debugFactory from 'debug';
import page from 'page';

/**
 * Internal Dependencies
 */
import { bootApp } from './common';

/**
 * Style dependencies
 */
import 'assets/stylesheets/styles.scss';


bootApp('Towersystems');



